import { render } from "./ProjectCreate.vue?vue&type=template&id=ca7b4d7e"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"
script.render = render

export default script